import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import Transition from '@ember/routing/-private/transition';
import ImportModel from 'cio/models/import';
import { Crumb } from 'cio/services/crumbs';
import EnvironmentService from 'cio/services/environment';
import { IdentifierKey, ObjectIdentifierKey } from 'cio/utils/identifiers';
import ImportsNew from './controller';
import RouteHistoryService from 'cio/services/route-history';
import DS from 'ember-data';

interface ModelParams {
  segmentId?: string;
  type?: string;
  objectTypeId?: string;
}
export default class ImportsNewRoute extends Route {
  @service environment!: EnvironmentService;
  @service router!: RouterService;
  @service routeHistory!: RouteHistoryService;
  @service store!: DS.Store;

  crumb(): Crumb {
    return {
      name: 'New',
      path: this.routeName,
    };
  }

  async model(params: ModelParams) {
    let importModel = this.store.createRecord('import', {
      validateRules: {
        onlyExisting: false,
        excludeExisting: false,
        noId: this.environment.current.isEmailIdentified,
        matchEmail: this.environment.current.canIdentifyByEmail,
        identifier: this.environment.current.canIdentifyByEmail ? IdentifierKey.Email : IdentifierKey.Id,
      },

      importRules: {
        clearEmptyCells: true,
      },
    });

    if (params.segmentId != null) {
      await importModel.setManualSegment.perform(params.segmentId);
    }

    if (params.type != null) {
      importModel.set('type', params.type);
    }

    if (params.objectTypeId != null) {
      importModel.setProperties({
        objectTypeId: params.objectTypeId,
        validateRules: {
          ...importModel.validateRules,
          identifier: ObjectIdentifierKey.ObjectId,
        },
      });
    }

    return importModel;
  }

  setupController(controller: ImportsNew, model: ImportModel, transition: Transition) {
    super.setupController(controller, model, transition);

    let { previousRouteName } = this.routeHistory;
    let { type }: ModelParams = this.paramsFor(this.routeName);

    if (previousRouteName == null) {
      if (type === 'object') {
        controller.previousRouteName = 'objects.type';
      } else {
        controller.previousRouteName = 'people';
      }
      return;
    }

    if (previousRouteName.includes('imports')) {
      controller.previousRouteName = 'imports';
    } else if (previousRouteName.includes('segments')) {
      controller.previousRouteName = 'segments.segment';
    } else if (previousRouteName.includes('objects')) {
      controller.previousRouteName = 'objects.type';
    } else {
      controller.previousRouteName = 'people';
    }
  }

  resetController(controller: ImportsNew, isExiting: boolean, _transition: Transition) {
    super.resetController(controller, isExiting, _transition);
    if (isExiting) {
      controller.resetQueryParams();
    }
  }
}
